import ManageSubscriptionTemplate from "../../components/SubscriptionTemplate/ManageSubscriptionTemplate";


export default function SubscriptionTemplate() {
  return (
    <>
    <ManageSubscriptionTemplate/>
    </>
  )
}